import { isAddress } from 'web3-validator';

export const getExplorerLink = (txHashOrAddress: string): string => {
  const sub = isAddress(txHashOrAddress) ? 'address/' : 'tx/';
  const scan =
    process.env.REACT_APP_USE_CHAIN === 'polygon'
      ? process.env.REACT_APP_MATIC_SCAN
      : process.env.REACT_APP_SEPOLIA_SCAN;
  return `${scan}${sub}${txHashOrAddress}`;
};
